(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ceslider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STATE = new WeakMap();

    function qs(root, sel){ return root.querySelector(sel); }
    function qsa(root, sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    function setup(root){
      if(!root || STATE.get(root)) return STATE.get(root);

      const track = qs(root, '.sg-track');
      const slides = qsa(root, '.sg-slide');
      const dots = qsa(root, '.sg-dot');
      const ctrCur = qs(root, '.sg-counter__current');
      const ctrTot = qs(root, '.sg-counter__total');

      if(!track || slides.length===0) return null;
      if(ctrTot){ ctrTot.textContent = String(slides.length); }

      let idx = 0;
      let timer = null;

      const autoplay = root.getAttribute('data-autoplay') === 'true';
      const interval = parseInt(root.getAttribute('data-interval') || '4000', 10);

      function go(i){
        idx = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-100*idx) + '%)';
        dots.forEach((d,di)=>d.classList.toggle('is-active', di===idx));
        if(ctrCur){ ctrCur.textContent = String(idx+1); }
        restart();
      }

      function play(){
        if(timer || !autoplay || slides.length<2) return;
        timer = setInterval(()=>go(idx+1), interval);
      }
      function pause(){ if(timer){ clearInterval(timer); timer=null; } }
      function restart(){ pause(); play(); }

      if('IntersectionObserver' in window){
        const io = new IntersectionObserver(([entry])=>{
          if(!entry) return;
          if(entry.isIntersecting) play(); else pause();
        }, {threshold: 0.1});
        io.observe(root);
      }
      document.addEventListener('visibilitychange', ()=>{ document.hidden ? pause() : play(); });

      const api = { go, play, pause, restart, get index(){return idx;} };
      STATE.set(root, api);
      go(0);
      return api;
    }

    function rootFrom(el){ return el.closest('.sg-section'); }

    document.addEventListener('click', (e)=>{
      const btn = e.target.closest('.sg-prev, .sg-next, .sg-dot');
      if(!btn) return;
      const root = rootFrom(btn);
      if(!root) return;
      const api = STATE.get(root) || setup(root);
      if(!api) return;

      if(btn.classList.contains('sg-prev')) api.go(api.index - 1);
      else if(btn.classList.contains('sg-next')) api.go(api.index + 1);
      else {
        const n = parseInt(btn.getAttribute('data-index') || '0', 10);
        api.go(n);
      }
    }, {passive:true});

    function initAll(ctx){
      (ctx || document).querySelectorAll('.sg-section').forEach(setup);
    }
    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', ()=>initAll(document));
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', (ev)=>initAll(ev.target || document));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
